<svg
  class="mc0"
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  viewBox="0 0 12 12"
  xml:space="preserve"
  #iconElement
>
  @if (icon === 'information') {
    <ng-container>
      <g transform="translate(-6104 17121)">
        <g transform="translate(4786 -18085)">
          <g transform="translate(-13547 24755)">
            <g transform="translate(14865 -23791)" fill="none">
              <path d="M6,0A6,6,0,1,1,0,6,6,6,0,0,1,6,0Z" [ngStyle]="{ fill: secondColor }" />
              <path
                d="M 6.000000476837158 1 C 3.242990493774414 1 1.000000953674316 3.242989540100098 1.000000953674316 6 C 1.000000953674316 8.757009506225586 3.242990493774414 11 6.000000476837158 11 C 8.757010459899902 11 11 8.757009506225586 11 6 C 11 3.242989540100098 8.757010459899902 1 6.000000476837158 1 M 6.000000476837158 0 C 9.31371021270752 0 12 2.68628978729248 12 6 C 12 9.31371021270752 9.31371021270752 12 6.000000476837158 12 C 2.686290740966797 12 9.5367431640625e-07 9.31371021270752 9.5367431640625e-07 6 C 9.5367431640625e-07 2.68628978729248 2.686290740966797 0 6.000000476837158 0 Z"
                [ngStyle]="{ fill: color }"
              />
            </g>
            <path
              d="M1.77,7.879a1.107,1.107,0,0,0,.395.848l1.3-.308a.536.536,0,0,1-.215-.4c0-.357.371-.569.789-.819.574-.318,1.208-.7,1.208-1.5,0-.9-.945-1.523-2.487-1.523A3.828,3.828,0,0,0,.144,5.1l.968.877a2.1,2.1,0,0,1,1.471-.6c.658,0,.933.251.933.549s-.323.472-.693.684C2.344,6.9,1.77,7.214,1.77,7.879Zm0,2.14a.9.9,0,0,0,.968.781.9.9,0,0,0,.968-.781.9.9,0,0,0-.968-.781A.9.9,0,0,0,1.77,10.019Z"
              transform="translate(14868.252 -23792.412)"
              [ngStyle]="{ fill: color }"
            />
          </g>
        </g>
      </g>
    </ng-container>
  }

  @if (icon === 'activityPin') {
    <ng-container>
      <path
        [ngStyle]="{ fill: color }"
        d="M 6,0.00209915 C 3.525,-0.0731228 1.575,1.8826479 1.5,4.3649722 c 0,3.0088779 4.0499999,7.3717518 4.1999999,7.5221948 0.15,0.150444 0.4500001,0.150444 0.6000001,0 0,0 0,0 0,0 C 6.45,11.736724 10.5,7.2986282 10.5,4.3649722 10.425,1.8826479 8.4749999,-0.0731228 6,0.00209915 Z M 7.5,4.0640844 H 6.375 v 1.2035512 c 0,0.2256658 -0.15,0.3761097 -0.375,0.3761097 -0.225,0 -0.375,-0.1504439 -0.375,-0.3761097 V 4.0640844 H 4.5 c -0.225,0 -0.375,-0.1504439 -0.375,-0.3008878 0,-0.1504439 0.15,-0.3761098 0.375,-0.3761098 H 5.6999999 V 2.1835357 c 0,-0.2256659 0.15,-0.3761098 0.3750001,-0.3761098 0.225,0 0.375,0.1504439 0.375,0.3761098 V 3.3870868 H 7.5 c 0.225,0 0.375,0.1504439 0.375,0.3761098 0,0.2256658 -0.15,0.3008878 -0.375,0.3008878 z"
        style="stroke-width: 0.751108"
      />
    </ng-container>
  }

  @if (icon === 'trash') {
    <ng-container>
      <path
        d="M 11.188503,1.8652607 H 8.594479 V 0.81077914 C 8.594479,0.36321031 8.231268,0 7.783699,0 H 4.217209 C 3.76964,0 3.406429,0.36321031 3.406429,0.81077914 V 1.8652607 H 0.812405 c -0.269479,0 -0.487405,0.2179262 -0.487405,0.4874048 0,0.2694786 0.217926,0.4874048 0.487405,0.4874048 h 0.688928 l 0.74048,8.4311657 C 2.281649,11.681312 2.63783,12 3.050249,12 h 5.90041 c 0.41242,0 0.766257,-0.321031 0.808436,-0.735794 l 0.74048,-8.426479 h 0.688928 c 0.269479,0 0.487405,-0.2179262 0.487405,-0.4874048 0,-0.2671353 -0.217926,-0.4850615 -0.487405,-0.4850615 z M 4.378896,0.97246632 H 7.622012 V 1.8652607 H 4.378896 Z M 8.805375,11.02519 H 3.195533 L 2.476142,2.837727 h 7.043937 z"
        style="stroke-width: 0.0234329"
        [ngStyle]="{ fill: color }"
      />
    </ng-container>
  }

  @if (icon === 'new-trash') {
    <ng-container>
      <path
        [ngStyle]="{ fill: color }"
        d="M 11.003138,1.726974 H 8.506428 V 1.319901 C 8.506428,0.592105 7.914322,0 7.186526,0 H 4.813171 C 4.085375,0 3.49327,0.592105 3.49327,1.319901 V 1.726974 H 0.99655904 C 0.811526,1.726974 0.6635,1.875 0.6635,2.060033 c 0,0.185033 0.148026,0.333059 0.33305904,0.333059 H 1.598533 V 10.21875 C 1.598533,11.200658 2.397875,12 3.379783,12 h 5.240131 c 0.981908,0 1.78125,-0.799342 1.78125,-1.78125 V 2.393092 h 0.601974 c 0.185033,0 0.333059,-0.148026 0.333059,-0.333059 0,-0.185033 -0.148026,-0.333059 -0.333059,-0.333059 z M 4.159388,1.319901 c 0,-0.360197 0.293586,-0.653783 0.653783,-0.653783 h 2.373355 c 0.360198,0 0.653783,0.293586 0.653783,0.653783 V 1.726974 H 4.159388 Z m 5.575658,8.898849 c 0,0.614309 -0.500822,1.115132 -1.115132,1.115132 H 3.379783 c -0.614309,0 -1.115132,-0.500823 -1.115132,-1.115132 V 2.393092 h 7.472862 v 7.825658 z"
        style="stroke-width: 0.0246711"
      />
      <path
        [ngStyle]="{ fill: color }"
        d="m 5.684059,9.824013 c 0.185033,0 0.333059,-0.148026 0.333059,-0.333059 V 3.604441 c 0,-0.185033 -0.148026,-0.333059 -0.333059,-0.333059 -0.185033,0 -0.333059,0.148026 -0.333059,0.333059 v 5.884046 c 0,0.185033 0.148026,0.335526 0.333059,0.335526 z"
        style="stroke-width: 0.0246711"
      />
      <path
        [ngStyle]="{ fill: color }"
        d="m 3.510539,9.456414 c 0.185033,0 0.33306,-0.148026 0.33306,-0.333059 V 3.969572 c 0,-0.185033 -0.148027,-0.333059 -0.33306,-0.333059 -0.185032,0 -0.333059,0.148026 -0.333059,0.333059 v 5.153783 c 0,0.185033 0.150494,0.333059 0.333059,0.333059 z"
        style="stroke-width: 0.0246711"
      />
      <path
        [ngStyle]="{ fill: color }"
        d="m 7.857579,9.456414 c 0.185033,0 0.333059,-0.148026 0.333059,-0.333059 V 3.969572 c 0,-0.185033 -0.148026,-0.333059 -0.333059,-0.333059 -0.185033,0 -0.333059,0.148026 -0.333059,0.333059 v 5.153783 c 0,0.185033 0.148026,0.333059 0.333059,0.333059 z"
        style="stroke-width: 0.0246711"
      />
    </ng-container>
  }

  @if (icon === 'chevronUp') {
    <ng-container>
      <path
        [ngStyle]="{ fill: color }"
        d="M 5.671566,2.8959937 0.13535817,8.4460483 c -0.18047756,0.1828129 -0.18047756,0.4757815 0,0.6586045 0.18282143,0.1804629 0.47580448,0.1804629 0.65862591,0 L 5.999707,3.8827254 11.20543,9.1023028 c 0.180478,0.1828129 0.475804,0.1828129 0.658626,0 C 11.955466,9.0109064 12,8.891361 12,8.7718357 12,8.6523003 11.95547,8.5351149 11.864056,8.4437084 L 6.3301919,2.8959937 C 6.2434689,2.8092971 6.1239318,2.760059 6.0020509,2.760059 5.8754822,2.7580591 5.758289,2.8069572 5.671566,2.8959937 Z"
        style="stroke-width: 0.0234381"
      />
    </ng-container>
  }

  @if (icon === 'chevronDown') {
    <ng-container>
      <path
        [ngStyle]="{ fill: color }"
        d="m 6.3292682,9.1027525 5.5348868,-5.54895 c 0.180436,-0.18279 0.180436,-0.47569 0,-0.65848 -0.182777,-0.18043 -0.47569,-0.18043 -0.658468,0 l -5.206825,5.22089 -5.20448144,-5.21854 c -0.18043452,-0.18278 -0.47569102,-0.18278 -0.65846884,0 C 0.04452281,2.9890625 0,3.1085625 0,3.2280825 c 0,0.1195 0.04452281,0.23667 0.13591172,0.32806 l 5.53488758,5.54895 c 0.086702,0.0867 0.2062109,0.13591 0.3280627,0.13591 0.1241953,0 0.2413605,-0.0492 0.3304062,-0.13825 z"
        style="stroke-width: 0.0234331"
      />
    </ng-container>
  }

  @if (icon === 'questionCircle') {
    <ng-container>
      <g transform="translate(14271,-15181)">
        <path
          [ngStyle]="{ fill: color }"
          d="m -14264.995,15190.44 c -0.26,0 -0.467,-0.212 -0.467,-0.467 0,-0.261 0.212,-0.468 0.467,-0.468 0.261,0 0.468,0.212 0.468,0.468 0,0.255 -0.212,0.467 -0.468,0.467 0,0 0,0 0,0 z m 0.468,-2.11 v -0.63 c 1.048,-0.266 1.677,-1.333 1.412,-2.376 -0.266,-1.043 -1.334,-1.677 -2.376,-1.412 -0.33,0.08 -0.635,0.256 -0.881,0.492 -0.379,0.364 -0.595,0.866 -0.595,1.392 0,0.261 0.211,0.468 0.467,0.468 0.256,0 0.467,-0.212 0.467,-0.468 v 0 c 0,-0.27 0.109,-0.531 0.305,-0.718 0.207,-0.197 0.483,-0.3 0.768,-0.29 0.561,0.01 1.003,0.472 0.994,1.033 -0.01,0.472 -0.345,0.875 -0.807,0.969 -0.409,0.08 -0.699,0.443 -0.694,0.861 v 0.674 c 0,0.26 0.212,0.467 0.467,0.467 0.256,0 0.473,-0.202 0.473,-0.462 z m 2.661,3.846 c 0.221,-0.132 0.29,-0.423 0.157,-0.644 -0.132,-0.221 -0.423,-0.29 -0.644,-0.157 v 0 c -2.41,1.47 -5.554,0.713 -7.025,-1.698 -1.47,-2.41 -0.713,-5.553 1.698,-7.024 2.41,-1.471 5.553,-0.713 7.024,1.697 1.038,1.697 0.994,3.842 -0.108,5.5 -0.148,0.216 -0.09,0.506 0.123,0.649 0.216,0.148 0.507,0.09 0.649,-0.123 0,0 0,0 0,0 1.84,-2.755 1.102,-6.478 -1.653,-8.318 -2.381,-1.589 -5.553,-1.279 -7.575,0.743 -2.347,2.346 -2.347,6.144 0,8.49 1.953,1.953 4.983,2.317 7.349,0.89 z"
          style="stroke-width: 0.0491912"
        />
      </g>
    </ng-container>
  }

  @if (icon === 'minusCircle') {
    <ng-container>
      <g transform="scale(0.70588235)">
        <circle [ngStyle]="{ fill: secondColor }" cx="8.5" cy="8.5" r="8.5" />
        <circle [ngStyle]="{ stroke: color }" style="fill: none" cx="8.5" cy="8.5" r="8" />
      </g>
      <g transform="matrix(0.70588235,0,0,0.70588235,4.3489412,4.3087059)">
        <path [ngStyle]="{ stroke: color }" style="fill: none; stroke-linecap: round" d="M 4.9,2.4 H 0" />
      </g>
    </ng-container>
  }

  @if (icon === 'plusCircle') {
    <ng-container>
      <g transform="scale(0.70588235)">
        <circle [ngStyle]="{ fill: secondColor }" cx="8.5" cy="8.5" r="8.5" />
        <circle [ngStyle]="{ stroke: color }" style="fill: none" cx="8.5" cy="8.5" r="8" />
      </g>
      <g transform="matrix(0.70588235,0,0,0.70588235,4.3489412,4.3087059)">
        <line
          [ngStyle]="{ stroke: color }"
          style="fill: none; stroke-linecap: round"
          x1="2.4000001"
          y1="0"
          x2="2.4000001"
          y2="4.9000001"
        />
        <path [ngStyle]="{ stroke: color }" style="fill: none; stroke-linecap: round" d="M 4.9,2.4 H 0" />
      </g>
    </ng-container>
  }

  @if (icon === 'plus') {
    <ng-container>
      <g style="enable-background: new" transform="scale(0.5)">
        <path
          [ngStyle]="{ fill: color }"
          d="m 13.5,20.1 h -3 V 13.2 H 4.4 v -2.7 h 6.1 V 3.9 h 3 v 6.6 h 6.1 v 2.7 h -6.1 z"
        />
      </g>
    </ng-container>
  }

  @if (icon === 'equals') {
    <ng-container>
      <g transform="scale(0.5)">
        <path [ngStyle]="{ fill: color }" d="M 4.4,10.2 H 19.6 V 7.5 H 4.4 Z m 0,6.3 H 19.6 V 13.8 H 4.4 Z" />
      </g>
    </ng-container>
  }

  @if (icon === 'camera') {
    <ng-container>
      <g transform="matrix(0.33333333,0,0,0.33333333,-24,0)">
        <g transform="translate(72)">
          <path
            [ngStyle]="{ fill: color }"
            d="M 4.5,5.5 V 1 h 3 V 5.5 H 12 v 3 H 7.5 V 13 h -3 V 8.5 H 0 v -3 z m 4.5,9 V 10 h 4.5 V 5.5 H 24 l 2.745,3 H 31.5 a 3.009,3.009 0 0 1 3,3 v 18 a 3.009,3.009 0 0 1 -3,3 h -24 a 3.009,3.009 0 0 1 -3,-3 v -15 z M 19.5,28 A 7.5,7.5 0 1 0 12,20.5 7.5,7.5 0 0 0 19.5,28 Z m -4.8,-7.5 a 4.8,4.8 0 1 0 4.8,-4.8 4.795,4.795 0 0 0 -4.8,4.8 z"
            transform="translate(0,0.5)"
          />
        </g>
      </g>
    </ng-container>
  }

  @if (icon === 'dropdown') {
    <ng-container>
      <g transform="matrix(0,0.74529996,-0.74529996,0,11.552149,1.0810201)">
        <line
          [ngStyle]="{ stroke: color }"
          style="fill: none; stroke-linecap: round; stroke-width: 2"
          x1="2.5999999"
          y1="14.5"
          x2="10.6"
          y2="7.5"
        />
        <path
          [ngStyle]="{ stroke: color }"
          style="fill: none; stroke-linecap: round; stroke-width: 2"
          d="m 2.7,0.4 7.9,7"
        />
      </g>
    </ng-container>
  }

  @if (icon === 'chevronRight') {
    <ng-container>
      <path
        [ngStyle]="{ fill: color }"
        d="M 7.9384324,6.0170584 2.5232287,10.680279 c -0.3008447,0.300853 -0.3760558,0.752132 -0.075211,1.052985 0.3008446,0.300853 0.7521115,0.376066 1.0529562,0.07521 L 9.5178667,6.5435511 c 0,0 0,-0.075213 0.075211,-0.075213 0,0 0,0 0,0 0,0 0,0 0,0 0.075211,-0.075213 0.075211,-0.1504264 0.1504224,-0.2256397 0,0 0,-0.075213 0,-0.075213 0,-0.075213 0,-0.075213 0,-0.1504265 0,-0.075213 0,-0.075213 0,-0.1504264 0,0 0,-0.075213 0,-0.075213 0,-0.075213 -0.075211,-0.1504265 -0.1504224,-0.2256397 0,0 0,0 0,0 0,0 0,0 0,0 0,0 0,-0.075213 -0.075211,-0.075213 L 3.576185,0.22563969 C 3.5009738,0.07521323 3.2753403,0 3.124918,0 2.8992845,0 2.7488622,0.07521323 2.5984399,0.22563969 2.2975952,0.52649261 2.3728064,0.977772 2.673651,1.2786249 Z"
        style="stroke-width: 0.752122"
      />
    </ng-container>
  }

  @if (icon === 'chevronLeft') {
    <ng-container>
      <path
        [ngStyle]="{ fill: color }"
        d="m 4.0615677,6.0170584 5.4152037,4.6632206 c 0.3008447,0.300853 0.3760558,0.752132 0.075211,1.052985 -0.3008446,0.300853 -0.7521115,0.376066 -1.0529562,0.07521 L 2.4821334,6.5435511 c 0,0 0,-0.075213 -0.075211,-0.075213 0,0 0,0 0,0 0,0 0,0 0,0 C 2.3317114,6.3931251 2.3317114,6.3179117 2.2565,6.2426984 c 0,0 0,-0.075213 0,-0.075213 0,-0.075213 0,-0.075213 0,-0.1504265 0,-0.075213 0,-0.075213 0,-0.1504264 0,0 0,-0.075213 0,-0.075213 0,-0.075213 0.075211,-0.1504265 0.1504224,-0.2256397 0,0 0,0 0,0 0,0 0,0 0,0 0,0 0,-0.075213 0.075211,-0.075213 L 8.4238151,0.22563969 C 8.4990263,0.07521323 8.7246598,0 8.8750821,0 9.1007156,0 9.2511379,0.07521323 9.4015602,0.22563969 9.7024049,0.52649261 9.6271937,0.977772 9.3263491,1.2786249 Z"
        style="stroke-width: 0.752122"
      />
    </ng-container>
  }

  @if (icon === 'search') {
    <ng-container>
      <path
        [ngStyle]="{ fill: color }"
        d="M 8.6,7.55 H 8.05 L 7.85,7.35 C 8.5,6.55 8.95,5.55 8.95,4.45 8.95,2 6.95,0 4.5,0 2.05,0 0,2 0,4.45 0,6.9 2,8.9 4.45,8.9 c 1.1,0 2.1,-0.4 2.9,-1.1 L 7.55,8 V 8.55 L 11,12 12,11 Z m -4.15,0 c -1.7,0 -3.1,-1.4 -3.1,-3.1 0,-1.7 1.4,-3.1 3.1,-3.1 1.7,0 3.1,1.4 3.1,3.1 0,1.7 -1.4,3.1 -3.1,3.1 z"
        style="stroke-width: 0.5"
      />
    </ng-container>
  }

  @if (icon === 'miniRv') {
    <ng-container>
      <g transform="matrix(0.34090909,0,0,0.34090909,0,2.2309091)">
        <g transform="translate(0,-1)">
          <path
            [ngStyle]="{ fill: color }"
            d="M 34.2,15 30.9,13.1 29.5,9.4 h 3.3 c 0.3,0 0.6,-0.3 0.6,-0.6 V 4.1 C 33.4,3.9 33.3,3.8 33.2,3.7 L 29.7,0.2 C 29.6,0.1 29.4,0 29.3,0 H 15.8 c -0.1,0 -0.2,0 -0.3,0.1 l -6.9,4 H 1.8 C 0.8,4.1 0,4.9 0,5.9 v 12.9 c 0,1 0.8,1.8 1.8,1.8 h 2.9 c 0,1.9 1.6,3.5 3.5,3.5 1.9,0 3.5,-1.6 3.5,-3.5 h 13.5 c 0,1.9 1.6,3.5 3.5,3.5 1.9,0 3.5,-1.6 3.5,-3.5 h 1.2 c 1,0 1.8,-0.8 1.8,-1.8 V 16.6 C 35.1,15.9 34.8,15.3 34.2,15 Z M 29.6,12.9 H 26.3 V 9.4 h 1.9 z M 8.2,22.8 c -1.3,0 -2.3,-1 -2.3,-2.3 0,-1.3 1,-2.3 2.3,-2.3 1.3,0 2.3,1 2.3,2.3 0,1.3 -1,2.3 -2.3,2.3 z m 13.5,-3.5 h -4.1 v -10 h 4.1 z m 7,3.5 c -1.3,0 -2.3,-1 -2.3,-2.3 0,-1.3 1,-2.3 2.3,-2.3 1.3,0 2.3,1 2.3,2.3 0,1.3 -1,2.3 -2.3,2.3 z M 34,18.7 c 0,0.3 -0.3,0.6 -0.6,0.6 H 32 c -0.6,-1.8 -2.6,-2.8 -4.5,-2.1 -1,0.4 -1.8,1.1 -2.1,2.1 H 22.9 V 8.8 C 22.9,8.5 22.6,8.2 22.3,8.2 H 17 c -0.3,0 -0.6,0.3 -0.6,0.6 V 19.3 H 11.5 C 10.9,17.5 8.9,16.5 7,17.2 6,17.6 5.2,18.3 4.9,19.3 H 1.8 C 1.5,19.3 1.2,19 1.2,18.7 V 5.9 C 1.2,5.6 1.5,5.3 1.8,5.3 h 7 c 0.1,0 0.2,0 0.3,-0.1 l 6.9,-4 h 13 l 3.2,3.2 v 3.9 h -6.4 c -0.3,0 -0.6,0.3 -0.6,0.6 v 4.7 c 0,0.3 0.3,0.6 0.6,0.6 h 4.5 l 3.4,1.9 c 0.2,0.1 0.3,0.3 0.3,0.5 0,-0.1 0,2.1 0,2.1 z"
          />
          <path
            [ngStyle]="{ fill: color }"
            d="M 11.9,8.3 H 5.1 C 4.8,8.3 4.5,8.6 4.5,8.9 v 0 3.4 c 0,0.3 0.3,0.6 0.6,0.6 v 0 h 6.8 c 0.3,0 0.6,-0.3 0.6,-0.6 v 0 -3.5 c 0,-0.3 -0.3,-0.5 -0.6,-0.5 z m -0.6,3.4 H 5.7 V 9.4 h 5.7 z"
          />
        </g>
      </g>
    </ng-container>
  }

  @if (icon === 'envelope') {
    <ng-container>
      <path
        [ngStyle]="{ fill: color }"
        d="M 10.875,1.5 H 1.125 C 0.50390625,1.5 0,2.003906 0,2.625 v 6.75 C 0,9.996094 0.50390625,10.5 1.125,10.5 h 9.75 C 11.496094,10.5 12,9.996094 12,9.375 V 2.625 C 12,2.003906 11.496094,1.5 10.875,1.5 Z m 0,0.75 c 0.05156,0 0.09844,0.01172 0.142969,0.02813 L 6,6.628125 0.98203125,2.278125 C 1.0265625,2.259375 1.0757812,2.25 1.125,2.25 Z m 0,7.5 H 1.125 C 0.91875,9.75 0.75,9.58125 0.75,9.375 V 3.070312 L 5.7539062,7.40625 C 5.8242182,7.46719 5.9132813,7.49766 6,7.49766 c 0.086719,0 0.1757812,-0.03047 0.2460937,-0.09141 L 11.25,3.070312 V 9.375 c 0,0.20625 -0.16875,0.375 -0.375,0.375 z"
        style="stroke-width: 0.0234375"
      />
    </ng-container>
  }

  @if (icon === 'smallRv') {
    <ng-container>
      <path
        [ngStyle]="{ fill: color }"
        d="M 10.781473,1.875189 H 4.6182869 V 1.72281 C 4.6182869,1.078125 4.0931619,0.553 3.4484772,0.553 H 2.4755894 c -0.6446848,0 -1.1698097,0.525125 -1.1698097,1.16981 V 1.875189 H 1.2213845 C 0.5485681,1.875189 0,2.423758 0,3.098919 v 6.13271 c 0,0.736113 0.59076564,1.336256 1.3245341,1.350321 0.1922333,0.506371 0.6821936,0.86505 1.2542048,0.86505 0.5720112,0 1.0619716,-0.358679 1.2542048,-0.86505 h 4.0228327 c 0.1945776,0.504026 0.6821937,0.86505 1.2542048,0.86505 0.5720113,0 1.0619728,-0.358679 1.2542048,-0.86505 h 0.67985 c 0.365712,0 0.665783,-0.297726 0.665783,-0.665783 V 7.508562 c 0,-0.0047 0,-0.0094 0,-0.01407 0.0047,-0.06564 -0.01172,-0.133625 -0.04454,-0.192233 L 10.44155,5.13143 h 0.745491 c 0.447762,0 0.813475,-0.363368 0.813475,-0.813476 v -1.221384 0 C 12.002816,2.423754 11.454291,1.875185 10.781475,1.875185 Z M 2.0090721,1.725154 c 0,-0.257874 0.2086433,-0.466517 0.4665173,-0.466517 h 0.9728878 c 0.2578739,0 0.4665173,0.208643 0.4665173,0.466517 V 1.875189 H 2.0090721 Z M 0.70329243,9.231629 V 7.827388 H 4.5104487 v 2.05127 H 3.9056173 C 3.7977791,9.24335 3.2445224,8.760423 2.5810832,8.760423 1.9199883,8.760423 1.3667316,9.241006 1.2588935,9.871625 0.94475619,9.827083 0.70329243,9.557488 0.70329243,9.231629 Z M 6.3647964,9.881002 H 5.2137412 V 5.131434 h 1.1510552 z m -3.7837132,0.862705 c -0.3539905,0 -0.6399961,-0.288349 -0.6399961,-0.639995 0,-0.353991 0.2883499,-0.639997 0.6399961,-0.639997 0.3539905,0 0.6399962,0.28835 0.6399962,0.639997 0,0.351646 -0.28835,0.639995 -0.6399962,0.639995 z m 6.5312423,0 c -0.3539904,0 -0.639996,-0.288349 -0.639996,-0.639995 0,-0.353991 0.2883499,-0.639997 0.639996,-0.639997 0.3516463,0 0.6399961,0.28835 0.6399961,0.639997 0,0.35399 -0.2860055,0.639995 -0.6399961,0.639995 z M 11.008871,9.881002 H 10.43686 C 10.329021,9.245694 9.7757647,8.762767 9.1123255,8.762767 c -0.6634392,0 -1.2166959,0.485273 -1.324534,1.118235 H 7.0680889 V 7.829733 H 11.008871 Z M 8.6739399,7.124096 V 5.131434 H 9.6351065 L 10.75803,7.124096 Z M 11.299566,4.320304 c 0,0.06095 -0.04923,0.110181 -0.110183,0.110181 H 8.3222937 c -0.035164,0 -0.070329,0.0047 -0.1031495,0.01407 -0.053919,0.01641 -0.1054939,0.04688 -0.1453471,0.08674 -0.039853,0.03985 -0.070329,0.09142 -0.08674,0.145347 -0.00938,0.03282 -0.014066,0.06798 -0.014066,0.10315 V 7.1241 H 7.0704332 V 5.110339 c 0,-0.375089 -0.2813169,-0.682194 -0.6282746,-0.682194 h -1.301091 c -0.3469575,0 -0.6282746,0.307105 -0.6282746,0.682194 V 7.1241 H 0.70329243 V 3.098923 c 0,-0.286006 0.2320865,-0.520437 0.51809207,-0.520437 h 9.5577445 c 0.286005,0 0.518093,0.232087 0.518093,0.518092 z"
        style="stroke-width: 0.0234431"
      />
      <path
        [ngStyle]="{ fill: color }"
        d="M 3.0194688,5.131434 H 2.1403533 c -0.1945776,0 -0.3516462,0.157069 -0.3516462,0.351646 0,0.194578 0.1570686,0.351646 0.3516462,0.351646 h 0.8814598 c 0.1945777,0 0.3516463,-0.157068 0.3516463,-0.351646 0,-0.194577 -0.1594131,-0.351646 -0.3539906,-0.351646 z"
        style="stroke-width: 0.0234431"
      />
    </ng-container>
  }

  @if (icon === 'garageDoor') {
    <ng-container>
      <path
        [ngStyle]="{ fill: color }"
        d="M 11.885156,0.09063635 C 11.8125,0.02501262 11.714063,-0.00779925 11.615625,0.00157557 L 0.31875,1.1265538 C 0.1359375,1.1453035 0,1.2953006 0,1.4757659 V 11.647445 C 0,11.841972 0.15703125,11.999 0.3515625,11.999 H 11.648438 C 11.842969,11.999 12,11.841972 12,11.647445 V 0.35078758 C 12,0.25235198 11.957812,0.15626009 11.885156,0.09063635 Z M 11.296875,0.73984256 V 2.5632449 H 0.703125 V 1.7945097 Z M 9.8671875,8.483443 H 2.0953125 V 7.7803316 h 7.771875 z m 0,-1.4062228 H 2.0953125 V 6.3741088 h 7.771875 z m -7.771875,2.1093342 h 7.771875 V 9.8896658 H 2.0953125 Z M 9.8671875,5.673341 H 2.0953125 V 4.9702296 h 7.771875 z m -7.771875,5.622548 v -0.703112 h 7.771875 v 0.703112 z m 8.4750005,0 V 4.6186739 c 0,-0.1945275 -0.157032,-0.3515557 -0.351563,-0.3515557 H 1.7460937 c -0.1945312,0 -0.3515625,0.1570282 -0.3515625,0.3515557 V 11.295889 H 0.703125 V 3.2640125 h 10.59375 v 8.0318765 z"
        style="stroke-width: 0.0234373"
      />
    </ng-container>
  }

  @if (icon === 'rvCircleFilled') {
    <ng-container>
      <g transform="matrix(0.33333333,0,0,0.33333333,-19.666667,-63)">
        <g transform="translate(59,189)">
          <circle [ngStyle]="{ fill: color }" cx="18" cy="18" r="18" />
          <g transform="translate(4.936,10.188)">
            <g transform="translate(0,-1)">
              <path
                [ngStyle]="{ fill: secondColor }"
                d="M 25.7,11.2 23.2,9.8 22.2,7 h 2.4 C 24.8,7 25,6.8 25,6.6 v 0 -3.5 C 25,3 25,2.9 24.9,2.8 L 22.3,0.2 C 22.2,0.1 22.1,0 22,0 H 11.9 c -0.1,0 -0.2,0 -0.2,0.1 l -5.2,3 H 1.3 C 0.6,3.1 0,3.7 0,4.4 V 14 c 0,0.7 0.6,1.3 1.3,1.3 h 2.2 c 0,1.5 1.2,2.6 2.6,2.6 1.5,0 2.6,-1.2 2.6,-2.6 h 10.1 c 0,1.5 1.2,2.6 2.6,2.6 1.5,0 2.6,-1.2 2.6,-2.6 h 1 c 0.7,0 1.3,-0.6 1.3,-1.3 v -1.7 c 0,-0.4 -0.2,-0.8 -0.6,-1.1 z M 22.2,9.7 H 19.8 V 7 h 1.5 z M 6.1,17.1 c -1,0 -1.8,-0.8 -1.8,-1.8 0,-1 0.8,-1.8 1.8,-1.8 1,0 1.8,0.8 1.8,1.8 v 0 c 0,1 -0.8,1.8 -1.8,1.8 z M 16.2,14.5 H 13.1 V 7 h 3.1 z m 5.3,2.6 c -1,0 -1.8,-0.8 -1.8,-1.8 0,-1 0.8,-1.8 1.8,-1.8 1,0 1.8,0.8 1.8,1.8 v 0 c 0,1 -0.8,1.8 -1.8,1.8 z m 4,-3.1 c 0,0.2 -0.2,0.4 -0.4,0.4 h -1 c -0.5,-1.4 -2,-2.1 -3.4,-1.6 -0.8,0.3 -1.3,0.9 -1.6,1.6 H 17.2 V 6.6 C 17.2,6.4 17,6.2 16.8,6.2 v 0 h -4 c -0.2,0 -0.4,0.2 -0.4,0.4 v 0 7.9 H 8.6 C 8.1,13.1 6.6,12.4 5.2,12.9 4.4,13.2 3.9,13.8 3.6,14.5 H 1.3 C 1.1,14.5 0.9,14.3 0.9,14.1 V 4.4 C 0.9,4.1 1.1,4 1.3,4 H 6.6 C 6.7,4 6.8,4 6.8,3.9 l 5.2,-3 h 9.8 l 2.4,2.4 V 6.2 H 19.4 C 19.2,6.2 19,6.4 19,6.6 v 0 3.5 c 0,0.2 0.2,0.4 0.4,0.4 v 0 h 3.4 l 2.5,1.4 c 0.1,0.1 0.2,0.2 0.2,0.4 z"
              />
              <path
                [ngStyle]="{ fill: secondColor }"
                d="M 5.9,6.7 H 2.5 C 2.4,6.7 2.2,6.8 2.2,7 V 7 8.7 C 2.2,8.9 2.3,9 2.5,9 V 9 H 5.8 C 6,9 6.1,8.9 6.1,8.7 V 8.7 7 C 6.1,6.8 6,6.7 5.9,6.7 Z M 5.6,8.4 H 2.8 V 7.2 h 2.8 z"
              />
            </g>
          </g>
        </g>
      </g>
    </ng-container>
  }

  @if (icon === 'mapPin') {
    <ng-container>
      <g transform="matrix(0.66658218,0,0,0.66658218,-11.665061,-67.325561)">
        <path
          [ngStyle]="{ fill: color }"
          d="m 26.5,101 c 4,-0.1 7.4,3.1 7.5,7.1 0,3.9 -7.5,10.9 -7.5,10.9 0,0 -7.5,-6.9 -7.5,-10.9 0.1,-4 3.5,-7.2 7.5,-7.1 z"
        />
      </g>
    </ng-container>
  }

  @if (icon === 'list') {
    <ng-container>
      <g transform="matrix(0.66666667,0,0,0.66664706,-536.66667,-259.65935)">
        <rect [ngStyle]="{ fill: color }" x="805" y="390" width="18" height="3" />
        <rect [ngStyle]="{ fill: color }" x="805" y="397" width="18" height="3" />
        <rect [ngStyle]="{ fill: color }" x="805" y="404" width="18" height="3" />
      </g>
    </ng-container>
  }

  @if (icon === 'save') {
    <ng-container>
      <path
        [ngStyle]="{ stroke: color }"
        d="M 6.1447976,11.224361 C 7.6259704,9.5689321 9.1071431,7.8263759 10.501188,6.2580754 c 1.21979,-1.3940449 1.5683,-3.3979846 0.08713,-4.7920295 0,0 -1.916812,-1.91681179 -4.6177741,0.6098947 h -0.08713 C 3.2695799,-0.5378937 1.2656403,1.4660459 1.2656403,1.4660459 -0.04127681,2.8600908 0.30723442,4.8640305 1.5270237,6.2580754 3.0081965,7.9135037 4.4893692,9.6560599 5.8834141,11.224361 Z"
        style="stroke-width: 0.871278; fill: none"
      />
    </ng-container>
  }

  @if (icon === 'saved') {
    <ng-container>
      <path
        [ngStyle]="{ fill: color }"
        d="M 6.1564963,11.703369 C 7.753598,9.9110051 9.3506997,8.0243065 10.853854,6.3262778 c 1.31526,-1.5093588 1.691049,-3.6790621 0.09395,-5.1884211 0,0 -2.0668371,-2.07536839 -4.979199,0.6603445 H 5.874655 C 3.0562402,-1.0318466 0.89545551,1.1378567 0.89545551,1.1378567 -0.5137518,2.6472157 -0.13796318,4.816919 1.177297,6.3262778 2.7743987,8.1186415 4.3715004,10.00534 5.8746549,11.703369 Z"
        style="stroke-width: 0.941409"
      />
    </ng-container>
  }

  @if (icon === 'rate') {
    <ng-container>
      <path d="M 0,0 H 12 V 12 H 0 Z" style="fill: none; stroke-width: 0.499999" />
      <path
        [ngStyle]="{ fill: color }"
        d="m 11,4.5999999 -3.6,-0.3 L 6,1 4.5999999,4.2999999 1,4.5999999 3.75,7 2.95,10.5 6.05,8.65 9.15,10.5 8.35,7 Z M 6,7.7 4.1,8.85 4.5999999,6.7 2.95,5.25 5.15,5.05 6,3.0500001 6.85,5.05 9.05,5.25 7.4,6.7 7.9,8.85 Z"
        style="stroke-width: 0.499999"
      />
    </ng-container>
  }

  @if (icon === 'navigate') {
    <ng-container>
      <path
        [ngStyle]="{ fill: color }"
        d="M 9.7550808,11.689006 C 9.6550287,11.588954 9.6050026,11.463888 9.6050026,11.338823 c 0,-0.125065 0.050026,-0.25013 0.1500782,-0.350182 L 10.305367,10.438354 H 6.4033351 c -0.025013,0 -0.025013,0 -0.050026,0 -1.4257426,-0.02501 -2.5763418,-1.200625 -2.5763418,-2.6263675 0,-1.4257426 1.1505992,-2.6013549 2.5763418,-2.6263679 0.025013,0 0.025013,0 0.050026,0 0.900469,0 1.6258468,-0.7253778 1.6258468,-1.6258468 0,-0.2251173 -0.050026,-0.4252215 -0.1250652,-0.6253257 C 7.8290776,2.7343418 7.7040125,2.5592507 7.5539343,2.4091725 7.253778,2.1090162 6.8285565,1.933925 6.4033351,1.933925 H 2.5263158 C 2.4762897,2.1090162 2.3762376,2.2590943 2.2511725,2.3841595 2.0010422,2.6342897 1.6758729,2.7593549 1.3256905,2.7593549 0.97550808,2.7593549 0.65033872,2.6342897 0.40020844,2.3841595 0.12506514,2.1340292 0,1.8088598 0,1.4586774 0,1.108495 0.12506514,0.78332571 0.37519541,0.5331954 c 0.50026056,-0.50026054 1.35070349,-0.50026054 1.85096409,0 0.1250651,0.12506521 0.2251172,0.2751433 0.3001563,0.4252215 h 3.8770193 c 0.025013,0 0.025013,0 0.050026,0 0.6753518,0 1.3256905,0.2751433 1.800938,0.7754038 0.5002606,0.5002606 0.7754039,1.1505993 0.7754039,1.8509641 0,0.7253778 -0.3001564,1.3757165 -0.7754039,1.850964 -0.4752475,0.4502345 -1.1005732,0.7503909 -1.800938,0.7754039 -0.025013,0 -0.025013,0 -0.050026,0 -0.900469,0 -1.6258468,0.7253778 -1.6258468,1.6258468 0,0.900469 0.7253778,1.6258465 1.6258468,1.6258465 H 10.305367 L 9.7550808,8.9125597 c -0.2001042,-0.2001043 -0.2001042,-0.5002606 0,-0.7003648 0.2001042,-0.2001042 0.5002602,-0.2001042 0.7003652,0 l 1.400729,1.4007291 c 0.05003,0.05003 0.07504,0.100053 0.100052,0.150079 0,0.02501 0,0.02501 0.02501,0.05003 0.02501,0.100052 0.02501,0.200104 0,0.300156 0,0.02501 0,0.02501 -0.02501,0.05003 -0.02501,0.05003 -0.05003,0.100052 -0.100052,0.150078 l -1.400729,1.40073 C 10.280354,11.88911 9.955185,11.88911 9.7550808,11.689006 Z"
        style="stroke-width: 0.25013"
      />
    </ng-container>
  }

  @if (icon === 'donate') {
    <ng-container>
      <g transform="matrix(0.24912231,0,0,0.24912231,0.02491223,0.01202435)">
        <path
          [ngStyle]="{ fill: color }"
          d="m 46.1,15.3 c -2.6,-1.5 -4.7,0.7 -5.5,1.6 -1.7,1.8 -3.7,3.5 -4.8,4.4 C 35.4,21.1 34.9,21 34.4,21 31.2,20.8 26.3,20.3 25,19.5 c -1.3,-0.8 -2.4,-1.6 -3.4,-2.3 -2.7,-2 -4.9,-3.5 -10.2,-3.5 -1.5,0 -2.9,0.4 -4.2,0.8 -1.3,0.4 -2.6,0.8 -4.2,0.8 -1.7,0 -3.1,1.4 -3.1,3.1 v 7.8 c 0,1.7 1.4,3.1 3.1,3.1 2.9,0 7.5,0.2 8.5,0.5 1.8,0.6 6.1,3.1 7.6,4 0,0 0,0 0.1,0 0.5,0.3 1.1,0.5 1.8,0.5 h 14.2 c 1.5,0 3.2,-1.4 3.8,-2.4 1.9,-3.1 8.5,-11.5 8.6,-11.6 0.1,-0.1 0.1,-0.2 0.2,-0.2 0.7,-1.7 0,-3.7 -1.7,-4.8 z m -11,16.2 H 20.9 c -0.1,0 -0.3,0 -0.4,-0.1 C 20,31.1 14.8,27.9 12.4,27.1 10.6,26.5 4.3,26.5 3,26.5 2.8,26.5 2.7,26.4 2.7,26.2 v -7.8 c 0,-0.2 0.1,-0.3 0.3,-0.3 2,0 3.6,-0.5 5,-1 1.2,-0.4 2.3,-0.7 3.4,-0.7 4.4,0 6,1.1 8.6,3 1,0.7 2.1,1.5 3.6,2.4 0.7,0.4 1.9,0.8 3.3,1 2.9,0.6 6.5,0.8 7.4,0.8 0,0 0,0 0.1,0 0.5,0 0.8,0.4 0.8,0.8 0,0.5 -0.4,0.8 -0.8,0.8 0,0 0,0 -0.1,0 L 23.7,26 c -0.8,0 -2.8,-1.4 -4.1,-2.4 -0.3,-0.2 -0.7,-0.5 -1,-0.7 -0.7,-0.5 -1.4,-0.9 -2,-1.2 -0.7,-0.3 -1.5,-0.1 -1.9,0.6 -0.3,0.7 -0.1,1.5 0.6,1.9 0.7,0.4 1.7,1 2.7,1.7 2.1,1.5 4.1,2.9 5.8,2.9 0,0 0,0 0.1,0 l 10.6,-0.6 c 2,0 3.6,-1.6 3.6,-3.6 0,-0.4 -0.1,-0.9 -0.2,-1.3 1.1,-0.9 3.1,-2.7 4.9,-4.5 1.2,-1.2 1.7,-1.3 2.1,-1.1 0.4,0.2 0.6,0.6 0.5,1.1 -0.9,1.2 -6.9,8.7 -8.7,11.7 -0.5,0.4 -1.3,1 -1.6,1 z"
        />
      </g>
    </ng-container>
  }

  @if (icon === 'locationPointer') {
    <ng-container>
      <path
        [ngStyle]="{ fill: color }"
        d="m 0.37785676,4.7156468 5.37033344,1.5236731 1.523676,5.3703231 c 0.1498698,0.499566 0.849262,0.499566 0.9991318,0.02498 L 11.967785,0.6941487 C 12.117655,0.29449673 11.718002,-0.10515525 11.31835,0.04471424 L 0.35287847,3.7165168 c -0.47458761,0.1748478 -0.47458761,0.8742387 0.0249783,0.99913 z M 2.1263374,4.1661253 10.718871,1.2686485 7.8213887,9.861166 v 0 0 L 6.5724739,5.440016 Z"
        style="stroke-width: 0.249783"
      />
    </ng-container>
  }

  @if (icon === 'rotateLeft') {
    <ng-container>
      <path
        d="m 4.5000795,3.4219485 c 0,0 -0.570955,-0.281258 1.500045,-0.281258 a -3.7501128,3.7501128 0 1 1 -3.750113,3.750113"
        style="fill: none; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 0.750023"
        [ngStyle]="{ stroke: color }"
      />
      <path
        style="fill: none; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 0.750023"
        d="m 6.0001245,1.3593865 -1.875057,1.875057 1.875057,1.875056"
        [ngStyle]="{ stroke: color }"
      />
    </ng-container>
  }

  @if (icon === 'rotateRight') {
    <ng-container>
      <path
        d="m 7.5048231,3.4219485 c 0,0 0.570955,-0.281258 -1.500045,-0.281258 a 3.7501128,3.7501128 0 1 0 3.750113,3.750113"
        style="fill: none; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 0.750023"
        [ngStyle]="{ stroke: color }"
      />
      <path
        style="fill: none; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 0.750023"
        d="m 6.0047781,1.3593865 1.875057,1.875057 -1.875057,1.875056"
        [ngStyle]="{ stroke: color }"
      />
    </ng-container>
  }

  @if (icon === 'compass') {
    <ng-container>
      <path
        d="M 11.376793,0.03253765 4.7204061,2.6950925 A 3.634887,3.634887 0 0 0 2.6950925,4.7204061 L 0.03253765,11.376793 a 0.45436088,0.45436088 0 0 0 0.59066942,0.590669 L 7.2795941,9.3049077 A 3.634887,3.634887 0 0 0 9.3049077,7.2795941 L 11.967462,0.62320707 A 0.45436088,0.45436088 0 0 0 11.376793,0.03253765 Z M 5.9999999,7.3630827 A 1.3630827,1.3630827 0 1 1 7.3630827,5.9999999 1.3630827,1.3630827 0 0 1 5.9999999,7.3630827 Z"
        style="stroke-width: 0.0567952"
        [ngStyle]="{ stroke: color }"
      />
    </ng-container>
  }

  @if (icon === 'slash') {
    <ng-container>
      <path
        d="M 3.1852137,11.299063 7.3848654,0.349971 C 7.4848571,0.1499876 7.6348444,0 7.8848236,0 v 0 c 0.349971,0 0.5999503,0.349971 0.4999586,0.6999419 L 4.1351349,11.649034 c -0.099992,0.199983 -0.2499793,0.349971 -0.4999585,0.349971 v 0 c -0.349971,0 -0.5999503,-0.349971 -0.4999586,-0.699942 z"
        style="stroke-width: 0"
        [ngStyle]="{ fill: color }"
      />
    </ng-container>
  }
</svg>
